import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Agents.scss';
import classNames from 'classnames/bind';
import {
  Dropdown,
  Button,
  Logo,
  Badge,
  MetaInfo,
  Spinner,
  Stars,
} from '../common';

import constants from '~/constants.js';

const cx = classNames.bind(styles);

class Agents extends React.Component {
  componentDidMount() {
    window.zE(() => window.zE.hide());
  }

  componentWillUnmount() {
    window.zE(() => window.zE.show());
  }

  render() {
    const {
      AgentsActions,
      section,
      sectionType,
      division,
      kic,
      agents,
      currentPage,
      totalPages,
      loadingAgents,
      loadingMoreAgents,
      getNextAgents,
    } = this.props;

    const logo = (
      <div className={cx('agents__logo')}>
        <Logo />
      </div>
    );

    const sectionDropdown = (
      <div className={cx('agents__dropdown')}>
        <Dropdown
          value={section}
          onChange={v => AgentsActions.selectSection(v)}
          size="small"
          iconName="map-marker"
        >
          {Object.keys(constants.sections).map(key => (
            <option key={key} value={key}>
              {constants.sections[key].name}
            </option>
          ))}
        </Dropdown>
      </div>
    );

    let divisionDefaultString;
    if (sectionType === 'city') {
      divisionDefaultString = '전체 구';
    } else if (sectionType === 'district') {
      divisionDefaultString = '전체 시/군';
    } else {
      divisionDefaultString = '전체';
    }
    const divisionDropdown = section !== '' && (
      <div className={cx('agents__dropdown')}>
        <Dropdown
          value={division}
          onChange={v => AgentsActions.selectDivision(v)}
          size="small"
        >
          <option value="all">{divisionDefaultString}</option>
          {constants.divisions[section].sort().map((sec, i) => (
            <option key={i} value={sec}>
              {sec}
            </option>
          ))}
        </Dropdown>
      </div>
    );

    const kicDropdown = (
      <div className={cx('agents__dropdown')}>
        <Dropdown
          value={kic}
          onChange={v => AgentsActions.selectKic(v)}
          size="small"
          iconName="building"
        >
          <option value="all">전체 업종</option>
          {constants.kics.map((ind, i) => (
            <option key={i} value={ind}>
              {ind}
            </option>
          ))}
        </Dropdown>
      </div>
    );

    const searchButton = (
      <div className={cx('agents__search-button')}>
        <Button
          iconName="fa fa-chevron-right"
          iconAlign="right"
          onClick={() => AgentsActions.changeSearchFilter()}
          size="small"
        >
          찾기
        </Button>
      </div>
    );

    const filters = (
      <div className={cx('agents__filters')}>
        <div className={cx('agents__filter-row')}>
          {sectionDropdown}
          {divisionDropdown}
        </div>
        <div className={cx('agents__filter-row')}>
          {kicDropdown}
          {searchButton}
        </div>
      </div>
    );

    const titleRow = agent => (
      <div className={cx('agents__item-row')}>
        <div className={cx('agents__item-row--left')}>
          <div className={cx('agents__item-name')}>
            {agent.favored && (
              <Badge border="secondary" text="secondary">
                인기
              </Badge>
            )}
            {agent.name}
          </div>
          <div className={cx('agents__item-clients', 'u-half-bold')}>
            <span className="u-text-important">{agent.clients}</span>개 사업장
            이용 중
          </div>
        </div>
        <div className={cx('agents__item-row--right')}>
          <Stars big current={agent.overallRatings} />
        </div>
      </div>
    );

    const addressRow = agent => (
      <div className={cx('agents__item-row', 'agents__item-address')}>
        {agent.address}
      </div>
    );

    const metaRow = agent => (
      <div className={cx('agents__item-row')}>
        <div
          className={cx(
            'agents__item-row--left',
            'agents__item-row--self-center'
          )}
        >
          {agent.favored ? (
            <div className={cx('agents__item-favored-description')}>
              <i className="fa fa-heart" />
              많은 고객사가 이용하는 세무대리인입니다.
            </div>
          ) : null}
          {agent.tags.length > 0 && (
            <div className={cx('agents__item-tags')}>
              {agent.tags.map((tag, i) => (
                <div key={i} className={cx('agents__item-tag')}>
                  #{tag}
                </div>
              ))}
            </div>
          )}
        </div>
        <div
          className={cx(
            'agents__item-row--right',
            'agents__item-row--self-end'
          )}
        >
          <div className={cx('agents__item-stats')}>
            <MetaInfo icon="fa fa-eye">{agent.views}</MetaInfo>
            <MetaInfo icon="fa fa-phone">{agent.calls}</MetaInfo>
            <MetaInfo icon="fa fa-comment">{agent.reviews}</MetaInfo>
          </div>
        </div>
      </div>
    );

    const agentList = loadingAgents ? (
      <Spinner size={20} />
    ) : (
      <div className={cx('agents__list')}>
        {agents.map(agent => (
          <Link
            key={agent.id}
            className={cx('agents__item')}
            to={`/agents/${agent.id}`}
          >
            {titleRow(agent)}
            {addressRow(agent)}
            {metaRow(agent)}
          </Link>
        ))}
      </div>
    );

    const moreButton = loadingMoreAgents ? (
      <Spinner size={20} />
    ) : (
      currentPage < totalPages && (
        <div className={cx('agents__more-button')}>
          <Button
            size="small"
            background="white"
            onClick={() => getNextAgents()}
          >
            더 보기
          </Button>
        </div>
      )
    );

    return (
      <div className={cx('agents')}>
        {logo}
        {filters}
        {agentList}
        {moreButton}
      </div>
    );
  }
}

export default Agents;



// WEBPACK FOOTER //
// ./src/components/Agents/Agents.js